import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AssignableRole } from '@property/shared';
import { api } from '@/lib/api';
import { captureMutationError } from '@/lib/sentry';
import { queryKeys } from '@/lib/query-keys';
import { toast } from '@/lib/toast';

export const ROLE_LABELS: Record<string, string> = {
  admin: 'Admin',
  user: 'User',
  agent: 'Agent',
  reviewer: 'Reviewer',
};

export function useSwitchUserRole() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, role }: { userId: string; role: AssignableRole }) =>
      api.switchUserRole(userId, role),

    onSuccess: (_, { role }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.users.all() });
      toast.success(`Role updated to ${ROLE_LABELS[role]}.`);
    },

    onError: (err, { userId, role }) => {
      captureMutationError(err, { mutation: 'useSwitchUserRole', userId, role });
      const message =
        err && typeof err === 'object' && 'message' in err
          ? String(err.message)
          : 'Failed to update role. Please try again.';
      toast.error(message);
    },
  });
}
